var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79167 11.4395V13.352C7.79167 14.9458 7.15417 15.5833 5.56042 15.5833H3.64792C2.05417 15.5833 1.41667 14.9458 1.41667 13.352V11.4395C1.41667 9.84575 2.05417 9.20825 3.64792 9.20825H5.56042C7.15417 9.20825 7.79167 9.84575 7.79167 11.4395Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 10.625C15.5833 13.3663 13.3663 15.5833 10.625 15.5833L11.3687 14.3438",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41667 6.37508C1.41667 3.63383 3.63376 1.41675 6.37501 1.41675L5.63126 2.65633",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3958 7.79175C14.1562 7.79175 15.5833 6.36466 15.5833 4.60425C15.5833 2.84384 14.1562 1.41675 12.3958 1.41675C10.6354 1.41675 9.20833 2.84384 9.20833 4.60425C9.20833 6.36466 10.6354 7.79175 12.3958 7.79175Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuota);
export default __webpack_public_path__ + "static/media/quota.cf192cfa8afa0c92b22e8f55bd6609eb.svg";
export { ForwardRef as ReactComponent };